<template>
  <div style="min-height: 300px">
    <div style="padding-left:10px">
      <span style="color: gray;font-size: 14px">总部：</span>
      <vxe-select v-model="tool.divsion" placeholder="全部" style="width: 80px" clearable>
        <vxe-option v-for="num in divsions" :key="num" :value="num" :label="`${num}`"></vxe-option>
      </vxe-select>
      <span style="color: gray;font-size: 14px;margin-left: 5px">部门：</span>
      <vxe-select v-model="tool.dept" placeholder="全部" style="width: 80px" clearable>
        <vxe-option v-for="num in depts" :key="num" :value="num" :label="`${num}`"></vxe-option>
      </vxe-select>
      <span style="color: gray;font-size: 14px;margin-left: 5px">姓名：</span>
      <vxe-input v-model="tool.name" placeholder="请输入姓名" clearable
                 style="width: 200px"></vxe-input>
      <vxe-button content="查询" @click="findData"></vxe-button>
    </div>
    <a-row>
      <a-col :span="6" v-for="rob in tableData">
        <a-card hoverable style="margin:10px;">
          <template #cover>
            <img v-if="rob.Photo==''" style="height: 200px;object-fit: contain"
                 alt=""
                 src="@/static/images/voteman.jpg"
            />
            <img v-else style="height: 200px;object-fit: contain"
                 alt=""
                 :src="rob.Photo"
            />
          </template>
          <a-card-meta>
            <template #title>
              <div style="width: 100%;font-weight: bold;text-align: center">{{ rob.developer }}</div>
            </template>
          </a-card-meta>
          <div>总部：{{ rob.division }}</div>
          <div>部门：{{ rob.dept }}</div>
          <div>流程：{{ rob.processID }}-{{ rob.processName }}</div>
          <div>年省时间/运行次数：{{ rob.saveTime }}H/{{ rob.runCount }}次</div>
          <div>得票数量：<span class="number">{{ rob.ticket }}</span> 票</div>
          <div>
            <a href="#" v-if="rob.pdd" @click="showPDD(rob.pdd)" class="detail">点击查看业务流程详情</a>
            <a v-else href="#" style="color:gray">点击查看业务流程详情</a></div>
          <div style="text-align: center;margin-top: 3px">

            <a-button type="primary" shape="round" @click="thumbsUp(rob.id)" v-if="rob.status=='0'">
              投他一票
            </a-button>
            <a-button v-else shape="round" disabled>已投票</a-button>

          </div>
        </a-card>
      </a-col>

    </a-row>

  </div>

</template>

<script>
import {reactive, ref, defineComponent} from 'vue'
import {VXETable, VxeTableInstance, VxeTablePropTypes} from 'vxe-table'
import Qs from 'qs'
import XEUtils from 'xe-utils'

export default defineComponent({
  name: "VoteListCard",
  data() {
    const tool = reactive({
      divsion: '',
      dept: '',
      name: ''
    })
    return {
      tableData: [],
      tool,
      divsions: [],
      depts: [],
      isShowDashbord: false,
      isLoading: false
    }
  },
  methods: {
    findData() {
      const params = {
        'uid': this.$store.state.userID,
        'email': this.$store.state.email,
        'currentPage': 1,
        'pageSize': 1000,  //
        'searchKey': [this.tool.name, this.tool.divsion, this.tool.dept, this.$store.state.userID]
      };
      this.$api.voteAPI.getVoteCurrentList(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          // console.log(res.data.Data);
          this.tableData = res.data.Data;
          //绑定总部和部门
          this.tableData.forEach((item) => {
            if (this.divsions.indexOf(item.division) == -1) {
              this.divsions.push(item.division)
            }
            if (this.depts.indexOf(item.dept) == -1) {
              this.depts.push(item.dept)
            }
          })
          this.divsions.sort();
          this.depts.sort()

        })
        .catch(error => {
          console.log(error);

        })
    },
    thumbsUp(votelistid) {
      const params = {
        'id': votelistid,
        'uid': this.$store.state.userID,
        'name': this.$store.state.userName
      };
      this.$api.voteAPI.thumbsUp(Qs.stringify(params))
        .then(res => {
          if (res.data.Success == false) {
            VXETable.modal.message({content: res.data.Message, status: 'error'});
            return;
          }
          VXETable.modal.message({content: '投票成功', status: 'success'});
          // this.findData();不及时刷新
          this.tableData.forEach((item) => {
            if (item.id == votelistid) {
              item.ticket += 1;
              item.status = '1'
            }
          })
        })
        .catch(error => {
          console.log(error);

        })
    },
    //打开PDD
    showPDD(pddPath) {
      if (pddPath == null || pddPath == '' || pddPath == 'null') {
        VXETable.modal.message({content: '请先维护效果评价', status: 'error'});
        return;
      }
      const url = '/pptxjs/index.html?processID=' + encodeURI(pddPath)
      window.open(url, '_blank');
    },
    keydown(e) {
      if (e.keyCode === 13) {
        this.findData();
      }
    }
  },
  mounted() {
    this.findData();
    window.addEventListener("keydown", this.keydown)

  },
  unmounted() {
    window.removeEventListener("keydown", this.keydown, false);

  },
})
</script>
<style src="../css/antd.css">
</style>
<style lang="css">

.number {
  display: inline-block;
  border-radius: 10px;
  background-color: #26A65B;
  height: 20px;
  min-width: 50px;
  text-align: center;
  vertical-align: middle;
  font-weight: bold;
  color: #fff;
}

.detail {
  color: red
}

.detail:hover {
  color: steelblue;
}

</style>

